import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Box } from '@mui/material';
import {
  Section,
  SectionTitle,
  ProductCard,
  AnimatedBox,
  GradientButton,
} from '../../components/ui';

// Product icons - save transparent icons to public/images/products/
const products = [
  {
    key: 'deenmatches',
    url: 'https://deenmatches.co.uk',
    image: '/images/products/deenmatches-icon.png',
  },
  {
    key: 'ubcconnect',
    url: 'https://ubc-connect.co.uk',
    image: '/images/products/ubc-connect-icon.png',
  },
  {
    key: 'suvaifoods',
    url: 'https://suvaifoods.co.uk/',
    image: '/images/products/suvai-foods-icon.png',
  },
  {
    key: 'watfordmosque',
    url: 'https://watfordmosque.nexfah.com',
    image: '/images/products/watford-mosque-icon.png',
  },
  {
    key: 'bookmoteasy',
    url: 'https://bookmoteasy.co.uk',
    image: '/images/products/bookmoteasy-icon.png',
  },
  {
    key: 'crux360',
    url: 'https://crux360.ai',
    image: '/images/products/crux360-icon.png',
  },
  {
    key: 'arimmigration',
    url: 'https://arimmigrationservices.co.uk/',
    image: '/images/products/ar-immigration-icon.svg',
  },
  {
    key: 'birminghamsleepcentre',
    url: 'https://birminghamsleepcentre.co.uk/',
    image: '/images/products/birmingham-sleep-centre-icon.svg',
  },
];

export default function ProductsSection() {
  const { t } = useTranslation();

  return (
    <Section>
      <Container maxWidth="lg">
        <SectionTitle
          title={t('products.title')}
          subtitle={t('products.subtitle')}
        />

        <Grid container spacing={4}>
          {products.map((product, index) => (
            <Grid item xs={12} md={4} key={product.key}>
              <AnimatedBox
                animation="fadeInUp"
                delay={`${index * 0.15}s`}
                sx={{ height: '100%' }}
              >
                <ProductCard
                  productKey={product.key}
                  title={t(`products.${product.key}.title`)}
                  description={t(`products.${product.key}.description`)}
                  features={t(`products.${product.key}.features`, { returnObjects: true })}
                  url={product.url}
                  image={product.image}
                />
              </AnimatedBox>
            </Grid>
          ))}
        </Grid>

        <AnimatedBox animation="fadeInUp" delay="0.5s">
          <Box sx={{ textAlign: 'center', mt: 6 }}>
            <GradientButton component={Link} to="/products" size="large">
              {t('common.viewAll')} {t('nav.products')}
            </GradientButton>
          </Box>
        </AnimatedBox>
      </Container>
    </Section>
  );
}
